import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{staticClass:"pt-2",style:({
    backgroundColor:
      _vm.pageOrigin === 'book' ? _vm.productSelected.collection_color : 'white',
  })},[_c(VCol,{attrs:{"cols":"12","md":"7"}},[_c('label',{class:['text-h6', _vm.pageOrigin === 'book' ? 'white--text' : '']},[_vm._v("Fornecedor: "+_vm._s(_vm.productSelected.provider_code)+" - "+_vm._s(_vm.productSelected.provider_name))]),_c(VDivider)],1),_c(VCol,{attrs:{"cols":"12","md":"5"}},[_c('label',{staticClass:"text-h6 white--text"},[_vm._v(" "+_vm._s(_vm.pageOrigin === "book" ? _vm.productSelected.collection : " ")+" ")]),_c(VDivider)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }